import { useNavigate } from "react-router-dom";

export default function TermsOfServicePage() {
  const navigate = useNavigate();
  const updated = "April 7, 2026";

  return (
    <div className="min-h-screen bg-white">
      {/* Nav */}
      <header className="border-b border-gray-100 px-6 py-4 flex items-center justify-between sticky top-0 bg-white z-10">
        <button onClick={() => navigate("/")} className="flex items-center gap-2 cursor-pointer">
          <div className="w-7 h-7 bg-[#16a34a] rounded-md flex items-center justify-center">
            <i className="ri-sun-line text-white text-xs"></i>
          </div>
          <span className="font-bold text-gray-900 text-base">SolarLead<span className="text-[#16a34a]">Source</span></span>
        </button>
        <button onClick={() => navigate(-1)} className="text-sm text-gray-500 hover:text-gray-800 flex items-center gap-1 cursor-pointer">
          <i className="ri-arrow-left-line"></i> Back
        </button>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-10">
          <h1 className="text-4xl font-bold text-gray-900 mb-3">Terms of Service</h1>
          <p className="text-sm text-gray-400">Last updated: {updated}</p>
        </div>

        <div className="space-y-8 text-gray-700 text-sm leading-relaxed">

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing or using the SolarLeadSource platform (&quot;Platform&quot;), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Platform. These terms apply to all installers, visitors, and users of the Platform.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. Platform Description</h2>
            <p>SolarLeadSource is a B2B marketplace that connects solar installation companies (&quot;Installers&quot;) with homeowners who have expressed interest in solar energy (&quot;Leads&quot;). We facilitate the purchase of exclusive leads but are not a party to any transaction between Installers and homeowners.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. Installer Accounts</h2>
            <p>To use the Platform, you must:</p>
            <ul className="list-disc pl-5 space-y-2 mt-3">
              <li>Be a licensed solar installation company or authorized representative</li>
              <li>Provide accurate and complete registration information</li>
              <li>Sign the Installer Partner Agreement</li>
              <li>Add a valid payment method via Stripe</li>
              <li>Maintain the security of your account credentials</li>
            </ul>
            <p className="mt-3">You are responsible for all activity that occurs under your account.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. Lead Purchases</h2>
            <h3 className="font-semibold text-gray-800 mb-2">4.1 Exclusivity</h3>
            <p>Each lead is sold exclusively to one installer. Once purchased, the lead will not be sold to any other party.</p>
            <h3 className="font-semibold text-gray-800 mb-2 mt-4">4.2 Reservation System</h3>
            <p>When you initiate a purchase, the lead is reserved for 5 minutes. If payment is not completed within this window, the lead is released back to the marketplace.</p>
            <h3 className="font-semibold text-gray-800 mb-2 mt-4">4.3 Refund Policy</h3>
            <p>Refunds may be requested within 48 hours of purchase if the lead&apos;s contact information is demonstrably invalid (disconnected phone number, invalid email address). Refunds are not issued for leads that do not convert to sales. All refund requests must be submitted to support@solarleadsource.com.</p>
            <h3 className="font-semibold text-gray-800 mb-2 mt-4">4.4 Pricing</h3>
            <p>Lead prices range from $100 to $200 and are displayed at the time of purchase. Prices are subject to change with 7 days notice.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-5 space-y-2 mt-3">
              <li>Resell, share, or distribute lead contact information to third parties</li>
              <li>Use lead information for any purpose other than solar sales</li>
              <li>Violate TCPA, CAN-SPAM, or any applicable telemarketing laws</li>
              <li>Attempt to circumvent the reservation or payment system</li>
              <li>Use automated tools to scrape or bulk-purchase leads</li>
              <li>Misrepresent your company or services to homeowners</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. Payment Terms</h2>
            <p>All payments are processed by Stripe. By adding a payment method, you authorize us to charge your card for lead purchases. All sales are final except as described in our refund policy. You are responsible for any applicable taxes.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">7. Intellectual Property</h2>
            <p>The Platform, including its design, features, and content, is owned by SolarLeadSource and protected by intellectual property laws. You may not copy, modify, or distribute any part of the Platform without our written permission.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">8. Disclaimers</h2>
            <p>THE PLATFORM IS PROVIDED &quot;AS IS&quot; WITHOUT WARRANTIES OF ANY KIND. WE DO NOT GUARANTEE THAT LEADS WILL RESULT IN SALES. WE ARE NOT RESPONSIBLE FOR THE ACTIONS OF HOMEOWNERS OR INSTALLERS. LEAD QUALITY IS BASED ON SELF-REPORTED HOMEOWNER DATA.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">9. Limitation of Liability</h2>
            <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, SOLARLEADSOURCE&apos;S LIABILITY IS LIMITED TO THE AMOUNT PAID FOR THE SPECIFIC LEAD IN QUESTION. WE ARE NOT LIABLE FOR LOST PROFITS, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">10. Termination</h2>
            <p>We reserve the right to suspend or terminate your account for violations of these Terms. You may close your account at any time by contacting support@solarleadsource.com. Termination does not affect your obligation to pay for leads already purchased.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">11. Governing Law</h2>
            <p>These Terms are governed by the laws of the State of Delaware. Any disputes shall be resolved through binding arbitration in accordance with the AAA Commercial Arbitration Rules.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">12. Changes to Terms</h2>
            <p>We may update these Terms at any time. We will notify you of material changes via email. Continued use of the Platform after changes constitutes acceptance of the new Terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">13. Contact</h2>
            <div className="bg-gray-50 rounded-xl p-4">
              <p className="font-semibold text-gray-900">SolarLeadSource</p>
              <p>Email: <a href="mailto:legal@solarleadsource.com" className="text-[#16a34a] hover:underline">legal@solarleadsource.com</a></p>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
